<div class="card approval-config-page">
  <div class="card-header approval-header">
    <div>
      <h5>Approval Config</h5>
      <!-- <p class="header-desc">
        Configure sequential approval levels for the selected account and service.
      </p> -->
    </div>
    <div class="service-control">
      <label for="approval-service">Service</label>
      <select
        id="approval-service"
        class="form-control"
        [(ngModel)]="selectedService"
        (change)="onServiceChange()"
      >
        <option *ngFor="let service of serviceOptions" [value]="service">
          {{ service }}
        </option>
      </select>
    </div>
  </div>

  <div class="card-body">
    <!-- <div class="account-context">
      <span>Account</span>
      <strong>{{ accountId || "-" }}</strong>
    </div> -->

    <div class="error-banner" *ngIf="errorMessage && !loading">
      {{ errorMessage }}
    </div>

    <div class="center loading-state" *ngIf="loading">
      <img src="../assets/img/loading_2.svg" alt="loading approval config" />
    </div>

    <div class="approval-workflow" *ngIf="!loading && configs.length > 0">
      <ng-container *ngFor="let config of configs; let last = last; trackBy: trackByLevel">
        <div
          class="approval-level-card"
          [ngClass]="{ disabled: !config.is_active }"
        >
          <div class="level-title">Level {{ config.approval_level }}</div>
          <div class="level-divider"></div>
          <div class="level-details">
            <div class="detail-row">
              <span class="detail-label">Level Name:</span>
              <span class="detail-value">{{ config.approval_level_name }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Approver Name:</span>
              <span class="detail-value">{{ config.approver_name }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Approver Email:</span>
              <span class="detail-value">{{ config.approver_email }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Status:</span>
              <span
                class="status-row"
                [ngClass]="config.is_active ? 'active' : 'inactive'"
              >
                <span class="status-dot"></span>
                <span>{{ config.is_active ? "Active" : "Disabled" }}</span>
              </span>
            </div>
          </div>
          <div class="level-actions">
            <button
              class="btn btn-light btn-sm"
              (click)="openEditModal(config)"
              [attr.disabled]="!writeAccess ? true : null"
            >
              <i class="fa fa-pencil"></i>
              Edit
            </button>
            <span
              class="disabled-button-help"
              [title]="getToggleDisabledReason(config)"
            >
              <button
                class="btn btn-sm"
                [ngClass]="config.is_active ? 'btn-danger-soft' : 'btn-success-soft'"
                (click)="openConfirmModal(config)"
                [attr.disabled]="getToggleDisabledReason(config) ? true : null"
              >
                {{ getStatusAction(config) }}
              </button>
            </span>
          </div>
        </div>

        <div class="workflow-arrow" *ngIf="!last">
          <i class="fa fa-arrow-down"></i>
        </div>
      </ng-container>
    </div>

    <div class="empty-state" *ngIf="!loading && !errorMessage && configs.length == 0">
      No approval levels configured for {{ selectedService }}.
    </div>

    <div class="add-level-row">
      <span class="disabled-button-help" [title]="getAddLevelDisabledReason()">
        <button
          class="btn btn-success-soft"
          (click)="openAddModal()"
          [attr.disabled]="getAddLevelDisabledReason() ? true : null"
        >
          <i class="fa fa-plus"></i>
          Add Level
        </button>
      </span>
    </div>
  </div>
</div>

<div class="approval-modal-backdrop" *ngIf="showFormModal">
  <div class="approval-modal">
    <div class="modal-header-row">
      <h5>{{ getModalTitle() }}</h5>
      <button class="btn btn-light btn-sm" type="button" (click)="closeFormModal()">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="modal-body-row">
      <div class="form-group mb-2">
        <label>Level</label>
        <input
          autocomplete="off"
          type="number"
          class="form-control"
          name="approvalLevel"
          [(ngModel)]="form.approval_level"
          [attr.disabled]="true"
        />
      </div>
      <div class="form-group mb-2">
        <label>Level Name</label>
        <input
          autocomplete="off"
          type="text"
          class="form-control"
          name="approvalLevelName"
          placeholder="Enter level name"
          [(ngModel)]="form.approval_level_name"
        />
      </div>
      <div class="form-group mb-2">
        <label>Approver Name</label>
        <input
          autocomplete="off"
          type="text"
          class="form-control"
          name="approverName"
          placeholder="Enter approver name"
          [(ngModel)]="form.approver_name"
        />
      </div>
      <div class="form-group mb-2">
        <label>Approver Email</label>
        <input
          autocomplete="off"
          type="email"
          class="form-control"
          name="approverEmail"
          placeholder="Enter approver email"
          [(ngModel)]="form.approver_email"
        />
      </div>
    </div>
    <div class="modal-actions">
      <button class="btn btn-light" type="button" (click)="closeFormModal()">
        Cancel
      </button>
      <button
        class="btn btn-success-soft"
        type="button"
        (click)="submitForm()"
        [attr.disabled]="saving ? true : null"
      >
        {{ saving ? "Saving..." : "Save" }}
      </button>
    </div>
  </div>
</div>

<div class="approval-modal-backdrop" *ngIf="showConfirmModal && pendingConfig">
  <div class="approval-modal confirm-modal">
    <div class="modal-header-row">
      <h5>{{ getConfirmTitle() }}</h5>
    </div>
    <div class="confirm-copy">
      Are you sure you want to {{ getConfirmAction() | lowercase }}
      <strong>Level {{ pendingConfig.approval_level }} - {{ pendingConfig.approval_level_name }}</strong>?
    </div>
    <div class="modal-actions">
      <button class="btn btn-light" type="button" (click)="closeConfirmModal()">
        Cancel
      </button>
      <button
        class="btn"
        type="button"
        [ngClass]="pendingConfig.is_active ? 'btn-danger-soft' : 'btn-success-soft'"
        (click)="confirmStatusChange()"
        [attr.disabled]="saving ? true : null"
      >
        {{ saving ? "Saving..." : getConfirmAction() }}
      </button>
    </div>
  </div>
</div>
